import useEligibleThermostatBrands from './useEligibleThermostatBrands'

function useViewModel() {
  const { brands } = useEligibleThermostatBrands()

  return {
    brands,
  }
}

export default useViewModel
